import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SubmitButton from '../../../../../../components/Buttons/SubmitButton';
import Selector from '../../../../../../components/Modules/Selector';
import DateRangeContainer from '../../../../../../components/Modules/DateRangeContainer';
import DateTimePicker from '../../../../../../components/Modules/DateTimePicker';
import * as options from './AutomateReportAndDeliveryOptions';
import './automateReportAndDelivery.less';


class AutomateReportAndDelivery extends Component {
    dateFormat = date => date.format('MM/DD/YYYY');

    select = (name, value) => {
      const { endTime } = this.props;

      const time = (name === 'startTime' || name === 'endTime')
        ? moment(value).startOf('hours').toDate()
        : value;

      this.props.setFormValue(name, time);

      if (name === 'startTime' && !endTime) {
        this.props.setFormValue('endTime', moment(time).add(1, 'hours'));
      }
    };

    render() {
      const {
        frequency,
        startTime,
        endTime,
      } = this.props;

      return (
        <div className="reports-tab-forms-automate">
          <Selector
                    clearable={false}
                    className="reports-tab-automate-frequency-selector"
                    options={options.frequency}
                    title="Email me a report"
                    value={frequency}
                    placeholder=""
                    onChange={this.select.bind(this, 'frequency')}
                />
          <DateRangeContainer className="reports-tab-automate-date-filter-selector">
            <DateTimePicker
                        value={startTime}
                        title="Start Searching On"
                        step={60}
                        time
                        min={moment().startOf('hours').subtract(1, 'hours').toDate()}
                        onChange={this.select.bind(this, 'startTime')} />
            <DateTimePicker
                        value={endTime}
                        title="Stop Searching on"
                        step={60}
                        time
                        min={moment(startTime).startOf('hours').toDate()}
                        onChange={this.select.bind(this, 'endTime')} />
          </DateRangeContainer>
          <div className="reports-tab-forms-automate-submit">
            <div className="submit-btn-spacer" />
            <SubmitButton
                        type="info"
                        size="normal"
                        onClick={this.props.automateMailing}
                        className="reports-tab-forms-automate-submit-button"
                    >Set Automated Report
            </SubmitButton>

            <a
                        className="set-automate-report-existing-reports"
                        href="/search-alerts#realtime-alerts-top"
                        target="_blank"
                    >Existing Reports
            </a>
          </div>
        </div>
      );
    }
}

AutomateReportAndDelivery.propTypes = {
  automateMailing: PropTypes.func.isRequired,
  setFormValue: PropTypes.func.isRequired,
  frequency: PropTypes.any.isRequired,
  startTime: PropTypes.any,
  endTime: PropTypes.any,
};

export default AutomateReportAndDelivery;



/** WEBPACK FOOTER **
 ** ./src/pages/filings/SearchCourtRecords/ReportsTab/ReportsTabForms/AutomateReportAndDelivery/AutomateReportAndDelivery.js
 **/